




































import Vue from "vue";
import Component from "vue-class-component";
import { maps, targets } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

interface ITargets {
  name: string;
  key: string;
}

@Component
export default class TargetsMenu extends Vue {
  //Data

  targets: ITargets[] = [
    {
      name: "Embarcaciones",
      key: "vessels",
    },
    {
      name: "Helicópteros",
      key: "sars",
    },
    {
      name: "AtoNs",
      key: "atons",
    },
    {
      name: "Estaciones base",
      key: "bs",
    },
  ];

  //computed

  get targetSelector() {
    return maps.getters.selectedTargets;
  }
  set targetSelector(value) {
    maps.commit(MutationTypes.SELECT_TARGETS, value);
  }

  get targetsCount() {
    return targets.getters.aisTargetsCount;
  }
}
